import React from 'react';
import { Trash2 } from 'lucide-react';

const DataTable = ({ currentData, currentCollection, activeTab, onDelete, deleteLoading }) => {
  // Get field names from first item, filtered appropriately for each collection
  const getDisplayFields = () => {
    if (currentData.length === 0) return [];

    const allFields = Object.keys(currentData[0]).filter(key => key !== 'id');

    // Define which fields to show for each collection type
    switch (activeTab) {
      case "serviceRequests":
        return allFields.filter(field => !['timestamp', 'userId'].includes(field));
      case "contractors":
        return allFields.filter(field => !['timestamp'].includes(field));
      case "contact":
        return allFields.filter(field => !['timestamp'].includes(field));
      case "customers":
        return ['fullName', 'email', 'phone', 'address', 'customerType', 'status'];
      default:
        return allFields.filter(field => !['timestamp', 'userId', 'createdAt', 'updatedAt'].includes(field));
    }
  };

  const fields = getDisplayFields();

  const formatValue = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }

    // Handle Firestore timestamp objects
    if (typeof value === "object" && value.seconds) {
      return new Date(value.seconds * 1000).toLocaleDateString();
    }

    // Handle regular Date objects
    if (value instanceof Date) {
      return value.toLocaleDateString();
    }

    // Handle address objects
    if (typeof value === "object" && value.street) {
      return `${value.street}, ${value.city}, ${value.state} ${value.zipCode}`;
    }

    // Handle other objects by stringifying them
    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    return value;
  };

  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="table">
          <thead className="table-header">
            <tr>
              {fields.map((field) => (
                <th key={field} className="table-header-cell">
                  {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                </th>
              ))}
              <th className="table-header-cell text-center">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-secondary-200">
            {currentData.map((item) => (
              <tr key={item.id} className="table-row">
                {fields.map((field) => (
                  <td key={field} className="table-cell">
                    <div className="max-w-xs">
                      {formatValue(item[field])}
                    </div>
                  </td>
                ))}
                <td className="table-cell text-center">
                  <button
                    onClick={() => onDelete(currentCollection, item.id)}
                    disabled={deleteLoading === item.id}
                    className="inline-flex items-center px-3 py-2 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {deleteLoading === item.id ? (
                      <div className="loading-spinner mr-1"></div>
                    ) : (
                      <Trash2 className="w-4 h-4 mr-1" />
                    )}
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;